/**
 * SAFICのドメイン
 */
export const DOMAIN_SAFIC = 'sompo-direct.ra-abas.jp'
export const DOMAIN_SAFIC_OLD = 'saison.ra-abas.jp' // NOTE:削除予定

/**
 * SJのドメイン
 */
export const DOMAIN_SJ = 'sompo-japan.ra-abas.jp'

/**
 * ZNのドメイン
 */
export const DOMAIN_ZN = 'zenjikyo.ra-abas.jp'

/**
 * NKRのドメイン
 */
export const DOMAIN_NKR = 'nikkaren.ra-abas.jp'

export default {
  SAFIC: DOMAIN_SAFIC,
  SAFIC_OLD: DOMAIN_SAFIC_OLD, // NOTE:削除予定
  SJ: DOMAIN_SJ,
  ZN: DOMAIN_ZN,
  NKR: DOMAIN_NKR,
}
